import Typography from '@mui/material/Typography';
import React from 'react';

import { EmphasisColorMap } from './typography.const';
import { TypographyProps } from './typography.types';

/**
 * @deprecated Use `Body` (regular) or `Label` (semibold) from `common/src/components/TypographyV2`
 * (e.g. `<Body size="small">` for 14/20/400, `<Label size="small">` for 14/16/600).
 */
export const Caption: React.FC<TypographyProps> = ({ className, emphasis = 'high', ...props }) => {
  return (
    <Typography
      variant="caption"
      className={className}
      color={EmphasisColorMap[emphasis]}
      {...props}
    />
  );
};
